import { RECIPES_RECEIVED } from './actions';

const initialState = [];

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case RECIPES_RECEIVED:
            return action.recipes;
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/recipes/reducer.js